import React, { lazy } from 'react';
import { AnimatedSection } from './AnimatedSection';
export function SolutionSection() {
  return <AnimatedSection className="px-4 py-8 md:py-14" data-id="element-92">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-6 md:gap-10" data-id="element-93">
        <div className="flex-1 text-center md:text-left" data-id="element-94">
          <h2 className="font-playfair text-2xl md:text-4xl font-bold mb-6 leading-tight" data-id="element-95">
            La <span className="text-[#d4a853]" data-id="element-96">Revelación</span>
          </h2>
          <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-4" data-id="element-97">
            He pasado los últimos meses "hackeando" los algoritmos de las IAs
            más potentes del mundo.
          </p>
          <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-4" data-id="element-98">
            El resultado es{' '}
            <span className="text-white font-bold" data-id="element-99">Nano-Creative Labs</span>: No
            es un curso aburrido, es una{' '}
            <span className="text-[#d4a853] font-semibold" data-id="element-100">
              transferencia de tecnología
            </span>
            .
          </p>
          <p className="text-white text-lg md:text-xl font-semibold font-playfair" data-id="element-101">
            Es el manual de guerra para la nueva era visual.
          </p>
        </div>

        <div className="relative flex-shrink-0" data-id="element-102">
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-103">
            <div className="w-48 h-48 rounded-full bg-[#d4a853]/8 blur-[60px]" data-id="element-104" />
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/gSF2vXRe6qeZsfde2hd5jZ/mk-01.png" alt="Nano-Creative Bible" loading="lazy" className="relative z-10 w-40 md:w-52 drop-shadow-2xl" data-id="element-105" />
        </div>
      </div>
    </AnimatedSection>;
}